import React, { useEffect, useRef } from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./AppOverviewWidget.css";

import VideoPoster from "../../../images/home-page/fast-secure-video-poster.png";
const AppOverviewWidget = () => {
    let videoRef = useRef(null);
    useEffect(() => {
        videoRef.current.play();
    });

    return (
        <WidgetContainer stylesClass="app-overview">
            <h1 className="app-overview-widget-main-heading">
                Simple, Fast &amp; Secure
            </h1>
            <div className="app-overview-widget-container">
                <div className="app-overview-widget-container__collapsible-container">
                    <h1 className="app-overview-widget-heading">
                        Simple, Fast &amp; Secure
                    </h1>
                    <div className="app-overview-widget-container__collapsible-container__item">
                        <div>
                            <h2>One app for all things money.</h2>
                        </div>
                        <p>
                            Pay bills, recharge, send money, buy gold, invest
                            and shop at your favourite stores.
                        </p>
                        <span className="content-bar"></span>
                    </div>
                    <div className="app-overview-widget-container__collapsible-container__item">
                        <div>
                            <h2>Pay whenever you like, wherever you like.</h2>
                        </div>
                        <p>
                            Choose from options like BHIM UPI, the PhonePe
                            wallet or your Debit and Credit Card.
                        </p>
                        <span className="content-bar"></span>
                    </div>
                    <div className="app-overview-widget-container__collapsible-container__item">
                        <div>
                            <h2>
                                Find all your favourite apps on PhonePe Switch.
                            </h2>
                        </div>
                        <p>
                            Book flights, order food or buy groceries. Use all
                            your favourite apps without downloading them.
                        </p>
                    </div>
                </div>

                <div
                    className="app-overview-widget-container__video-container"
                    title="PhonePe - India’s Payments App"
                >
                    <video
                        autoplay
                        loop
                        preload
                        muted
                        ref={videoRef}
                        poster={VideoPoster}
                        disableRemotePlayback
                        playsInline
                    >
                        <source src="https://website.phonepe.com/assets/page/home-fast-secure.mp4"></source>
                    </video>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default AppOverviewWidget;
